import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";


 
const icon2 = "https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2026/03/Untitled-design-1.png";
const icon4 = "https://winpeforum.com/assets/elements/bhavna.png";
const icon12 = "https://winpeforum.com/assets/elements/HardikaShah.jpg";

let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/sheshines/2july2026/1.jpg";
const I2 = "https://www.winpeforum.com/assets/sheshines/2july2026/18.jpg";
const I3 = "https://www.winpeforum.com/assets/sheshines/2july2026/3.jpg";
const I4 = "https://www.winpeforum.com/assets/sheshines/2july2026/4.jpg";
const I5 = "https://www.winpeforum.com/assets/sheshines/2july2026/18.jpg";
const I6 = "https://www.winpeforum.com/assets/sheshines/2july2026/6.jpg";
const I7 = "https://www.winpeforum.com/assets/sheshines/2july2026/7.jpg";
const I8 = "https://www.winpeforum.com/assets/sheshines/2july2026/8.jpg";
const I9 = "https://www.winpeforum.com/assets/sheshines/2july2026/19.jpg";
 

 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/1.jpg";
const II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/18.jpg";
const II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/3.jpg";
const II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/4.jpg";
const II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/18.jpg";
const II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/6.jpg";
const II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/7.jpg";
const II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/8.jpg";
const II9 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/19.jpg";
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    this.Speaker1 = [
       {
          imgUrl: icon2,
          desc: `<div>
        Anjali Sosale is a GP at WaterBridge Ventures where she focuses on consumption and the gig economy. She was previous with Myntra Jabong and EY in leadership roles and is based in Bangalore. WaterBridge is a VC firm that partners with founders early, with a $1-3M cheque and continues to invest until Series C. 
          
          </div>`,
          name: "AnjaIi Sosale",
          post: `<div>Partner<br/> WaterBridge Ventures<br/>(Speaker)
  
  
          </div>`,
        },
         {
            imgUrl: icon12,
            desc: `As the solo founder of fintech Kinara Capital, Hardika is recognized social entrepreneur and a dedicated advocate of Financial Inclusion. With the pioneering use of AI and tech-enabled solutions, Kinara Capital advanced the lives of over 1 lakh small business owners across 100+ cities in India that in turn impacted over half a million lives in local economies with new job creation and income generation. <br/><br/>

As a purpose-driven entrepreneur, Hardika has been recognized for her leadership in building inclusive finance solutions and for championing gender equality in the workplace.  <br/><br/>
Her accolades include being named among the Forbes India W-Power List of Top 20 Self-Made Women, receiving the Economic Times Startup Award, the United Nations award for Leadership, and national recognition by the Government of India as one of the Top 75 Women Entrepreneurs Transforming India.  <br/><br/>
Hardika has also been invited as a TEDx speaker, and her unique story has been featured by The Better India, Humans of Bombay, Mint newspaper, Entrepreneur magazine and more.  <br/><br/>

Before founding Kinara Capital, Hardika spent nearly two decades in Management Consulting working across the US, Europe, and Asia-Pacific, and mentoring social entrepreneurs through leading global institutions. <br/><br/>s

Hardika holds a Bachelor’s degree in Computer Science from Knox College and an MBA from the joint program of Columbia Business School and UC Berkeley Haas School of Business.
`,
            name: "Hardika Shah",
            post: `<div>Founder & CEO <br/>Kinara Capital<br/>(Speaker)</div>`,
            
          }, 
       
 
      
   {
        imgUrl: icon4,
        desc: `<div>
      Bhavna Suresh is an entrepreneur renowned for attracting top-tier talent and architecting margin-centric, scalable strategies across the Asia-Pacific region. A lifelong learner, she thrives in collaborative environments alongside diverse experts and is dedicated to refining the art of deep listening.<br/><br/>

In 2020, she achieved a successful exit from a multi-million-dollar PropTech venture, a milestone reached alongside her exceptional team.<br/><br/>

Bhavna is deeply committed to cross-cultural collaboration, with a steadfast focus on driving inclusion and championing women’s representation in the workforce.<br/><br/>

She is the founder of Stylebank and holds an MBA from HEC Paris, as well as an Engineering degree from VTU Bangalore.

        
        
        </div>`,
        name: "Bhavna Suresh        ",
        post: `<div>Venture Partner

<br/>
       Antler<br/>(Moderator)
        
  
  
        </div>`,
      },
 
      

      
    ];

    this.Speaker2 = [
       
      
   
      
    ];
    this.CollegiumsImages = [
      { id:23, ImgSrc: I1, ImgSrc1: II1,},   
      
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   

        { id:22, ImgSrc: I6, ImgSrc1: II6,},   
        { id:19, ImgSrc: I7, ImgSrc1: II7,},  
        { id:35, ImgSrc: I8, ImgSrc1: II8,},   
        { id:34, ImgSrc: I9, ImgSrc1: II9,},  
      
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="sheshines with Winpe"
          image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
          description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! "
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">sheshines with Winpe </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>July 2, 2026 (5:00 - 8:00 PM IST)</span>
                  <br/>
                  <span> <i>Bangalore International Centre (BIC), Bengaluru</i></span>
                </div>
              </div>
              <center><h3>The Honest Debrief — What We Got Wrong on Both Sides of the Table
</h3><br/>
             
           
          </center>  
              
              <div className="top_text" style={{textAlign:'justify'}}>
          On July 2, 2026, Winpe sheshines brought together women from the investing and entrepreneurial ecosystem for a candid conversation on the decisions, assumptions and turning points that shape a founder’s and an investor’s journey. Moving beyond polished success stories, the discussion explored how experience changes judgment and how leaders learn from difficult choices.<br/><br/>
         <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Event Highlights</h2> <div class="r_btm"></div>
The discussion challenged the idea that every setback can be neatly labelled a failure. Speakers explored the assumptions behind difficult decisions, the role of trusted truth-tellers and the importance of taking a longer view of success and setbacks. 
<br/><br/>

  A community poll had identified ‘hiring the wrong people’ as the most expensive startup mistake, opening a wider conversation on evolving teams, trust and leadership through change. The founder–investor relationship was also examined candidly from understanding different forms of capital and investor constraints to retaining founder conviction. The conversation further touched on crisis, difficult conversations and loneliness in leadership.

              <br/><br/>
   <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Our Key Takeaways</h2>          <div class="r_btm"></div>
<ul>
 
<li>
<b>Own the decision, not just the outcome</b><br/> 
Good reflection means understanding why you made a decision, not judging it only by what happened later.
<br/><br/></li>
<li>
<b>Think in decades, not days</b><br/> 
A single setback or success should not define a long journey. A wider time horizon brings perspective and equanimity.
<br/><br/></li>
<li>
<b>Build a circle of trust — and let it evolve</b><br/>
Leaders need truth-tellers who challenge assumptions honestly, while recognising that the advice required changes with each stage.
<br/><br/></li>
<li>
<b>The people who build may not be the people who stabilise</b><br/>
Different phases call for different strengths. The team that drives growth may not always be best equipped for crisis or transition.
<br/><br/>
</li><li>
<b>Understand the colour of capital</b><br/>
Fund timelines, return expectations and institutional constraints shape investor behaviour. Understanding them early can prevent misalignment.<br/><br/>
</li><li>
<b>Investors can enable; founders must retain conviction</b><br/>
Investors bring perspective and networks, but founders must continue to own operating judgment and key decisions.
<br/><br/>

</li><li>
<b>Growth cannot cover fundamental cracks</b><br/>
Scale cannot compensate for weak governance, unresolved people issues or structural fragility; it can amplify what remains unaddressed.
<br/><br/>

</li><li>
<b>Loneliness has more than one form</b><br/>
Leadership can be isolating in decisions, relationships and even at home. The support systems that sustain a long journey matter.

<br/><br/>
</li>
</ul>
The Honest Debrief offered a simple lens: understand why a decision was made, recognise when a belief needs to change and carry the learning forward. That spirit sits at the heart of sheshines creating a trusted space for women across the private equity, venture capital and entrepreneurial ecosystem to share experiences, exchange perspectives and build meaningful relationships.





              </div>
              <br />

              <br />
             

             
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'20px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                 <br/>
  <br/> 
     <center>  
         <a href="gallery/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button">View All Images</button> </a> </center> 
       
          <br/><br/>
         <div className="row"> 
                          
               <div className="col-md-12">   

                  <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers & Moderator</h2>          <div class="r_btm"></div>
                      
                 
                     
                      <div className="Our_Speakers container">
                                <center>
                                  <div className="Speakers_img" style={{ width: '65%' }}>
                                    <div className="row">
        
                                      {this.Speaker1.map((item, i) => {
                                       if(i<=3) 
                                       {
                                        return (
                                          <div
                                            className="main_speaker_card col-md-4 col-sm-12 col-lg-4"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                       }
                                       else 
                                       return (
                                          <div
                                            className="main_speaker_card col-md-4 col-sm-12 col-lg-4"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
        
                                </center>
                              </div>
        </div>
        
                
</div> 

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/sheshines2July2026/index.js